<template>
  <p class="error-icon-message my-3 col-md-12"><slot></slot></p>
</template>

<script>
export default {
  name: 'IconErrorMessage'
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.error-icon-message {
  padding-left: 43px;
  color: $color_danger;
  font-weight: normal;
  &::before {
    content: "";
    position: absolute;
    top: 4px;
    left: 15px;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    background: url(../../assets/img/error_icon_01.png) 50% 50% no-repeat;
    background-size: 18px;
  }
}
</style>
